import request from '@/utils/request';
var api = {
  common: '/ysa-base/common'
};

// 上传图片地址
export function uploadImageUrl() {
  return '/api' + api.common + '/uploadFile';
}
export function uploadFile(parameter) {
  // 上传文件
  return request({
    url: '/ysa-base/common/uploadFile',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: parameter
  });
}

// 更新用户头像
export function updateAvatar(parameter) {
  return request({
    url: '/ysa-system-service/SysUserInfo/updateAvatar',
    method: 'post',
    data: parameter
  });
}